"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tour = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var tour = function tour(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'tour-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M1.75 10C1.75 9.01534 2.47725 7.96621 4.00027 7.12008C5.49789 6.28808 7.61764 5.75 10 5.75C12.3824 5.75 14.5021 6.28808 15.9997 7.12008C17.5228 7.96621 18.25 9.01534 18.25 10C18.25 10.685 17.9066 11.3907 17.1747 12.054C16.4409 12.7189 15.3568 13.2987 14.0134 13.6964C13.6162 13.814 13.3896 14.2313 13.5071 14.6284C13.6247 15.0256 14.042 15.2523 14.4392 15.1347C15.9361 14.6916 17.2389 14.02 18.1819 13.1655C19.1267 12.3094 19.75 11.2278 19.75 10C19.75 8.22323 18.4625 6.77237 16.7282 5.80885C14.9684 4.83121 12.5882 4.25 10 4.25C7.4118 4.25 5.03155 4.83121 3.27181 5.80885C1.53747 6.77237 0.25 8.22323 0.25 10C0.25 11.7768 1.53747 13.2276 3.27181 14.1912C4.8073 15.0442 6.81523 15.5954 9.02152 15.7221L7.23253 17.4273C6.9327 17.7131 6.92133 18.1879 7.20712 18.4877C7.49291 18.7875 7.96765 18.7989 8.26748 18.5131L11.4254 15.503L11.9949 14.9601L11.4254 14.4172L8.26748 11.4071C7.96765 11.1213 7.49291 11.1327 7.20712 11.4325C6.92133 11.7324 6.9327 12.2071 7.23253 12.4929L9.04535 14.2209C7.05368 14.0985 5.29462 13.599 4.00027 12.8799C2.47725 12.0338 1.75 10.9847 1.75 10Z',
    fill: '#4B5563'
  }));
};

exports.tour = tour;